// routes/realtime.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'

const getClientModule = () => import('src/clientRoutes/realtime')

export const handle = { name: 'realtime' }

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
